import React, { useState } from 'react'
import Modal from 'react-modal'
import LoadingSpinner from '../../components/LoadingSpinner'
import ChangePasswordModal from '../../components/profile/ChangePasswordModal'
import { PageTitle } from '../../layout/core'
import { useQuery } from '@apollo/client'
import { GET_BG_ACCOUNT_BY_ID, GET_USER_BY_ID } from '../../graphql/query'
import EditProfileModal from '../../shared/EditProfileForm'
import EditBusinessModal from '../../shared/EditBusinessForm'
import { maskEmail, maskPhoneNum } from '../../utils/functions/maskData'
import AgentOperatorProfilePage from './AgentOperatorProfilePage'
import WhiteLabelComponent from './WhiteLabelComponent'

const ProfilePage: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  // const [selectedImage, setSelectedImage] = useState<any>(null)
  // const [prevImage, setPrevImage] = useState<any>(defaultImage)
  const [isProfileModalOpen, setIsProfileModalOpen] = useState<boolean>(false)
  const [isBusinessModalOpen, setIsBusinessModalOpen] = useState<boolean>(false)

  const openProfileModal = () => {
    setIsProfileModalOpen(true)
  }

  const afterOpenProfileModal = () => {
    // subtitle.style.color = '#f00'
  }

  const closeProfileModal = () => {
    setIsProfileModalOpen(false)
  }

  const openBusinessModal = () => {
    setIsBusinessModalOpen(true)
  }

  const afterOpenBusinessModal = () => {
    // subtitle.style.color = '#f00'
  }

  const closeBusinessModal = () => {
    setIsBusinessModalOpen(false)
  }

  // function handleImageUpload(event: any) {
  //   const file = event.target.files[0]
  //   setSelectedImage(file)
  //   const reader: any = new FileReader()
  //   reader.onloadend = () => {
  //     setPrevImage(reader.result)
  //   }
  //   reader.readAsDataURL(file)
  // }

  // function handleImageDelete() {
  //   setPrevImage(defaultImage)
  // }

  const openModal = () => {
    setIsModalOpen(true)
  }

  const afterOpenModal = () => {
    // subtitle.style.color = '#f00'
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  const customModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-40%, -50%)',
      border: 'none'
    }
  }

  const { loading, error, data } = useQuery(GET_USER_BY_ID)
  console.log(data)
  const { loading: loading1, error: error1, data: data1 } = useQuery(GET_BG_ACCOUNT_BY_ID)

  if (loading) {
    return <h1>Loading...</h1>
  }

  if (error) {
    return <p>error</p>
  }
  if (loading1) {
    return <h1>Loading...</h1>
  }

  if (error1) {
    return <p>error</p>
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>Profile</PageTitle>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          {(data.getUserById.UserRole[0].roleId === 5 ||
            data.getUserById.UserRole[0].roleId === 3) && <AgentOperatorProfilePage data={data} />}
          {data.getUserById.UserRole[0].roleId !== 5 &&
            data.getUserById.UserRole[0].roleId !== 3 && (
              <>
                <div className='card mb-5 mb-xl-10'>
                  <div
                    className='card-header border-0 cursor-pointer'
                    role='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#kt_account_profile_details'
                    aria-expanded='true'
                    aria-controls='kt_account_profile_details'
                  >
                    <div className='card-title m-0'>
                      <h3 className='fw-bold m-0'>Profile Details</h3>
                    </div>
                    <div className='card-footer d-flex justify-content-end py-6 px-1'>
                      <div className='ms-auto' title='Edit your profile details'>
                        <div
                          onClick={openProfileModal}
                          className='btn btn-light btn-active-light-primary'
                        >
                          Edit
                        </div>
                        <Modal
                          isOpen={isProfileModalOpen}
                          onAfterOpen={afterOpenProfileModal}
                          onRequestClose={closeProfileModal}
                          style={customModalStyles}
                          contentLabel='Edit Personal Details'
                        >
                          <EditProfileModal
                            closeProfileModal={closeProfileModal}
                            loading={loading}
                            error={error}
                            data={data}
                          />
                        </Modal>
                      </div>
                    </div>
                  </div>

                  <div id='kt_account_settings_profile_details' className='collapse show'>
                    <form id='kt_account_profile_detail_form' className='form'>
                      <div className='card-body border-top p-9'>
                        <div className='row mb-6'>
                          <label className='col-lg-4 col-form-label required fw-semibold fs-6'>
                            Full Name
                          </label>

                          <div className='col-lg-8 fv-row'>
                            <input
                              type='text'
                              name='Full Name'
                              className='form-control form-control-lg form-control-solid'
                              placeholder='Full Name'
                              value={data.getUserById.name}
                            />
                          </div>
                        </div>

                        <div className='row mb-6'>
                          <label className='col-lg-4 col-form-label fw-semibold fs-6'>
                            <span className='required'>Contact Phone</span>
                            <span
                              className='ms-1'
                              data-bs-toggle='tooltip'
                              title='Phone number must be active'
                            ></span>
                          </label>

                          <div className='col-lg-8 fv-row'>
                            <input
                              type='tel'
                              name='phone'
                              className='form-control form-control-lg form-control-solid'
                              placeholder='Contact number'
                              value={maskPhoneNum(data.getUserById.contactNumber)}
                            />
                          </div>
                        </div>

                        <div className='row mb-6'>
                          <label className='col-lg-4 col-form-label required fw-semibold fs-6'>
                            Email
                          </label>

                          <div className='col-lg-8 fv-row'>
                            <input
                              type='text'
                              name='Email Id'
                              className='form-control form-control-lg form-control-solid'
                              placeholder='Email'
                              value={maskEmail(data.getUserById.email)}
                            />
                          </div>
                        </div>

                        <div className='row mb-6'>
                          <label className='col-lg-4 col-form-label required fw-semibold fs-6'>
                            Department
                          </label>

                          <div className='col-lg-8 fv-row'>
                            <input
                              type='text'
                              name='Department'
                              className='form-control form-control-lg form-control-solid'
                              placeholder='Department'
                              value={data.getUserById.Department}
                            />
                          </div>
                        </div>

                        <div className='row mb-6'>
                          <label className='col-lg-4 col-form-label required fw-semibold fs-6'>
                            Designation
                          </label>

                          <div className='col-lg-8 fv-row'>
                            <input
                              type='text'
                              name='Designation'
                              className='form-control form-control-lg form-control-solid'
                              placeholder='Designation'
                              value={data.getUserById.Designation}
                            />
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className='card mb-5 mb-xl-10'>
                  <div
                    className='card-header border-0 cursor-pointer'
                    role='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#kt_account_profile_details'
                    aria-expanded='true'
                    aria-controls='kt_account_profile_details'
                  >
                    <div className='card-title m-0'>
                      <h3 className='fw-bold m-0'>Business Details</h3>
                    </div>
                    <div className='card-footer d-flex justify-content-end py-6 px-1'>
                      {data.getUserById.UserRole[0].roleId === 1 && (
                        <>
                          <div className='ms-auto' title='Edit your business details'>
                            <div
                              onClick={openBusinessModal}
                              className='btn btn-light btn-active-light-primary'
                            >
                              Edit
                            </div>
                            <Modal
                              isOpen={isBusinessModalOpen}
                              onAfterOpen={afterOpenBusinessModal}
                              onRequestClose={closeBusinessModal}
                              style={customModalStyles}
                              contentLabel='Edit Business Details'
                            >
                              <EditBusinessModal
                                closeBusinessModal={closeBusinessModal}
                                loading={loading1}
                                error={error1}
                                data={data1}
                              />
                            </Modal>
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  <div id='kt_account_settings_profile_details' className='collapse show'>
                    <form id='kt_account_profile_details_form' className='form'>
                      <div className='card-body border-top p-9'>
                        <div className='row mb-6'>
                          <label className='col-lg-4 col-form-label required fw-semibold fs-6'>
                            Organization{' '}
                          </label>

                          <div className='col-lg-8 fv-row'>
                            <input
                              type='text'
                              name='Organization Name'
                              className='form-control form-control-lg form-control-solid'
                              placeholder='Organization Name'
                              value={data1.getBgAccountById.organization}
                            />
                          </div>
                        </div>

                        <div className='row mb-6'>
                          <label className='col-lg-4 col-form-label required fw-semibold fs-6'>
                            Location{' '}
                          </label>

                          <div className='col-lg-8 fv-row'>
                            <input
                              type='text'
                              name='Location'
                              className='form-control form-control-lg form-control-solid'
                              placeholder='Location'
                              value={data1.getBgAccountById.location}
                            />
                          </div>
                        </div>

                        <div className='row mb-6'>
                          <label className='col-lg-4 col-form-label required fw-semibold fs-6'>
                            Industry{' '}
                          </label>

                          <div className='col-lg-8 fv-row'>
                            <input
                              type='text'
                              name='Industry'
                              className='form-control form-control-lg form-control-solid'
                              placeholder='Industry'
                              value={data1.getBgAccountById.industry}
                            />
                          </div>
                        </div>

                        <div className='row mb-6'>
                          <label className='col-lg-4 col-form-label required fw-semibold fs-6'>
                            Company Size{' '}
                          </label>

                          <div className='col-lg-8 fv-row'>
                            <select
                              className=' form-select form-select-solid form-select '
                              value={data1.getBgAccountById.companySize}
                              name='companySize'
                            >
                              <option key='blankKey' hidden>
                                Select
                              </option>
                              <option value='belowTwenty'>Below 20</option>
                              <option value='twentyOneToFifty'>21 to 50</option>
                              <option value='fiftyOneToTwoHundred'>51 to 100</option>
                              <option value='twoHundredOneToFiveHundred'>201 to 500</option>
                              <option value='fiveHundredOneToThousand'>501 to 1000</option>
                              <option value='thousandPlus'>1000+ </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </>
            )}
          <div className='card mb-5 mb-xl-10'>
            <div
              className='card-header border-0 cursor-pointer'
              role='button'
              data-bs-toggle='collapse'
              data-bs-target='#kt_account_signin_method'
            >
              <div className='card-title m-0'>
                <h3 className='fw-bold m-0'>Reset Password</h3>
              </div>
            </div>

            <div id='kt_account_settings_signin_method' className='collapse show'>
              <div className='card-body border-top p-5'>
                <div className='d-flex flex-wrap align-items-center mb-4 mt-2'>
                  <div id='kt_signin_password'>
                    <div className='fs-6 fw-bold mb-1'>Password</div>
                    <div className='fw-semibold text-gray-600'>************</div>
                  </div>

                  <div id='kt_signin_password_edit' className='flex-row-fluid d-none'>
                    <form id='kt_signin_change_password' className='form' noValidate>
                      <div className='row mb-1'>
                        <div className='col-lg-4'>
                          <div className='fv-row mb-0'>
                            <label
                              htmlFor='currentpassword'
                              className='form-label fs-6 fw-bold mb-3'
                            >
                              Current Password
                            </label>
                            <input
                              type='password'
                              className='form-control form-control-lg form-control-solid'
                              name='currentpassword'
                              id='currentpassword'
                              autoComplete='current-password'
                            />
                          </div>
                        </div>
                        <div className='col-lg-4'>
                          <div className='fv-row mb-0'>
                            <label htmlFor='newpassword' className='form-label fs-6 fw-bold mb-3'>
                              New Password
                            </label>
                            <input
                              type='password'
                              className='form-control form-control-lg form-control-solid'
                              name='newpassword'
                              id='newpassword'
                              autoComplete='new-password'
                            />
                          </div>
                        </div>
                        <div className='col-lg-4'>
                          <div className='fv-row mb-0'>
                            <label
                              htmlFor='confirmpassword'
                              className='form-label fs-6 fw-bold mb-3'
                            >
                              Confirm New Password
                            </label>
                            <input
                              type='password'
                              className='form-control form-control-lg form-control-solid'
                              name='confirmpassword'
                              id='confirmpassword'
                              autoComplete='confirm-password'
                            />
                          </div>
                        </div>
                      </div>
                      <div className='form-text mb-5'>
                        Password must be at least 8 character and contain symbols
                      </div>
                      <div className='d-flex'>
                        <button
                          id='kt_password_submit'
                          type='button'
                          className='btn btn-primary me-2 px-6'
                        >
                          Update Password
                        </button>
                        <button
                          id='kt_password_cancel'
                          type='button'
                          className='btn btn-color-gray-400 btn-active-light-primary px-6'
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </div>

                  <div className='ms-auto' title='Click to change your password'>
                    <div onClick={openModal} className='btn btn-light btn-active-light-primary'>
                      Change Password
                    </div>
                    <Modal
                      isOpen={isModalOpen}
                      onAfterOpen={afterOpenModal}
                      onRequestClose={closeModal}
                      style={customModalStyles}
                      contentLabel='Edit User'
                    >
                      <ChangePasswordModal setIsLoading={setIsLoading} closeModal={closeModal} />
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {data.getUserById.UserRole[0].roleId === 1 && <WhiteLabelComponent />}
        </>
      )}
    </>
  )
}

export { ProfilePage }
